import { Controller } from '@hotwired/stimulus'

// Fila del selector de cotizaciones (`menu-selector` del sistema de diseño) en
// la portada y en el filtro de región de los listados. Cuando la fila no cabe se
// desplaza en horizontal, y el DS tapa el borde derecho con un degradado blanco
// mientras queda contenido oculto. Este controlador enciende ese degradado
// (`is-overflowing`, el CSS lo pinta) y lo apaga al llegar al final, para que la
// última opción se lea entera, y al cargar desplaza la fila hasta la opción activa
// si quedaba oculta. Sin JS la fila se desplaza igual, sin degradado.

// Ancho del degradado del DS (capa `blur` de `menu-selector-mobile`).
const GRADIENT_WIDTH = 22

export default class extends Controller {
  static targets = ['row']

  connect() {
    this.revealActive()
    this.update()
    // Poppins llega después del primer pintado y cambia el ancho de la fila.
    document.fonts?.ready.then(() => {
      this.revealActive()
      this.update()
    })
  }

  // En los listados la opción activa puede ser una del final (p. ej. «de EE.UU.»):
  // si la fila no cabe, quedaría oculta bajo el degradado. Se desplaza la fila lo
  // justo para que se lea entera, sin mover la página.
  revealActive() {
    const active = this.rowTarget.querySelector('.is-active')
    if (!active) return

    const hidden = active.getBoundingClientRect().right - this.rowTarget.getBoundingClientRect().right
    if (hidden > 0) this.rowTarget.scrollLeft += hidden + GRADIENT_WIDTH
  }

  update() {
    const { scrollLeft, scrollWidth, clientWidth } = this.rowTarget
    // 1px de holgura: con zoom, `scrollLeft` llega con decimales al final.
    this.element.classList.toggle('is-overflowing', scrollLeft + clientWidth < scrollWidth - 1)
  }

  // Al pulsar una pestaña cambia cuál lleva la etiqueta (con su relleno), y con
  // ello el ancho de la fila; el radio se marca después del clic.
  refresh() {
    requestAnimationFrame(() => this.update())
  }
}
